import React, { Fragment } from 'react';
import { DataTable, DataTableConstant, TableToolType, TableRowAction, CollapsibleRowType } from 'hub-dashboard-framework'
import authService from '../../../api-authorization/AuthorizeService';
import Utilities, { UtilConstant } from 'hub-utilities'
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HubApi from 'util/HubApi'
import storyLockClient from '../../../../store/scn/StoryLockClient';
import { mapDispatchToHubObjectBoardProps } from 'store/actions/HubObjectBoardActions';
import { mapDispatchToMetadataProps } from 'store/actions/HubMetadataActions';
import { mapDispatchToProps } from 'store/actions/HubConfigActions';
import { Row, Col } from 'react-bootstrap';

import * as Logger from 'loglevel';
import * as _ from 'lodash'

import * as HubConstant from 'util/HubConstant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faPlaneArrival, faUserEdit, faCity, faStopwatch, faTags, faListAlt, faFileAudio, faExclamationTriangle, faLock} from '@fortawesome/free-solid-svg-icons';

import { extractNodesFromData, extractNodeGroups, extractCategories, onReceivePropsParseMetadata, navigateDataObj } from '../../libraries/DataHandler'

import 'styles/tables/NewsItem.scss'
import memoize from 'memoize-one'
import update from 'immutability-helper'

class Story extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props);
        this.state = {
            activeNodeId: props.nodeId,
            fetchedData: [],
            activeNodeName: "All",
            urgentCheckboxState: DataTableConstant.HUB_CHECKBOX_STATE.EMPTY,
            hasMediaCheckboxState: DataTableConstant.HUB_CHECKBOX_STATE.EMPTY,
            lockedStories: {} 
        };
        this.headerConfig = {
            id: -1,
            type: HubConstant.HUB_OBJECT_STORY,
            ProductionCentre: { val: "null", canSort: true, headerIcon: faCity },
            Title: { val: "null", canSort: true },
            Arrived: { val: "null", canSort: true, date: "", isInitiallySorted: true, headerIcon: faPlaneArrival, hasRowIcon: true },
            CreatedBy: { val: "null", canSort: false, headerIcon: faUserEdit },

            Duration: { val: "null", canSort: true, headerIcon: faStopwatch },
            Tags: { val: "null", canSort: false, headerIcon: faTags },
            Collapsible: null,
            rowActions: [
                { action: TableRowAction.EDIT_ROW, minAuthorityRequired: UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN, userPermission: HubConstant.USER_FOLDER_PERMISSIONS.MODIFY },
                { action: TableRowAction.DELETE_ROW, minAuthorityRequired: UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN, userPermission: HubConstant.USER_FOLDER_PERMISSIONS.DELETE },
                { action: TableRowAction.DOWNLOAD_ALL_MEDIA, minAuthorityRequired: UtilConstant.HUB_USER_TYPE.HUB_USER, userPermission: HubConstant.USER_FOLDER_PERMISSIONS.READ },
            ]
        }
        this.onOpenForm = this.onOpenForm.bind(this);
    }

    async componentWillMount() {
        await authService.getAccessTokenAsync()
        await this.fetchFilterBarData();
    }

    async fetchFilterBarData() {
        await this.props.getNodeGroups(false, false);
        await this.props.getMetadata();
        await this.props.requestNodes();
    }

    componentDidMount() {
        this._isMounted = true;

        this.initializeLockClient();
    }

    initializeLockClient() {

        storyLockClient.setLockCallbacks({
            onLockAcquired: this.handleLockAcquired,
            onLockDenied: this.handleLockDenied,
            onInitialLocks: this.handleInitialLocks,
            onLockReleased: this.handleLockReleased
        });
        storyLockClient.initialize().then(() => {
            // After SignalR connection is established, get current locks
            storyLockClient.getCurrentLocks().then(currentLocks => {
                if (currentLocks) {
                    this.handleInitialLocks(currentLocks);
                }
            });
        });
    }

    componentWillUnmount() {
        this._isMounted = false;

        if (storyLockClient) {
            storyLockClient.disconnect();
        }
    }

    refreshTableData = () => {
        if (this.props.objectList && this.props.objectList.length > 0) {
            const transformedTableData = this.fetchData(this.props.objectList);
            this.setState({ fetchedData: transformedTableData });
        }
    }

    cleanupStaleLocalLocks = () => {
        const reduxLocks = this.props.storyLocks || {};
        const localLocks = this.state.lockedStories;

        const staleLockIds = Object.keys(localLocks).filter(storyId => {
            const reduxLock = reduxLocks[storyId];
            return !reduxLock; 
        });

        if (staleLockIds.length > 0) {
            Logger.debug("Cleaning up stale local locks:", staleLockIds);

            const cleanedLocks = { ...localLocks };
            staleLockIds.forEach(storyId => {
                delete cleanedLocks[storyId];
            });

            this.setState({ lockedStories: cleanedLocks });
            return true; 
        }

        return false; 
    }

    handleLockAcquired = (storyId) => {
        if (!this._isMounted) return;

        Logger.debug("Lock acquired for story:", storyId);

        this.setState(prevState => ({
            lockedStories: {
                ...prevState.lockedStories,
                [storyId]: {
                    lockedByMe: true,
                    userId: authService.getCurrentHubUser().id,
                    connectionId: storyLockClient.getConnectionId()
                }
            }
        }), () => {
            if (this.props.updateStoryLocks) {
                this.props.updateStoryLocks({
                    ...this.props.storyLocks,
                    [storyId]: {
                        userId: authService.getCurrentHubUser().id,
                        connectionId: storyLockClient.getConnectionId(),
                        lockTime: new Date().toISOString()
                    }
                });
            }

            this.refreshTableData();

            const storyObject = this.props.objectList.find(obj => obj.id === storyId);
            if (storyObject && this._isMounted) {
                this.props.onOpenForm(
                    HubConstant.HUB_STORY_EDIT_FORM,
                    TableRowAction.EDIT_INFO_BY_FORM,
                    {
                        ...storyObject,
                        id: storyId,
                        type: HubConstant.HUB_OBJECT_STORY,
                        folderId: storyObject.folderId,
                        onFormClose: () => this.handleEditFormClose(storyId)
                    }
                );
            }
        });
    }

    handleLockDenied = (storyId, userId) => {
        Logger.debug("Lock denied for story:", storyId, "Already locked by user:", userId);

        const currentUserId = authService.getCurrentHubUser().id
        const user = this.props.users ? this.props.users.find(u => u.id === userId) : null;
        const userName = user ? user.userName : "Another user";

        const isSameUser = userId === currentUserId;

        this.setState(prevState => ({
            lockedStories: {
                ...prevState.lockedStories,
                [storyId]: {
                    lockedByMe: false,
                    userId: userId,
                    connectionId: null
                }
            }
        }), () => {
            if (this.props.updateStoryLocks) {
                this.props.updateStoryLocks({
                    ...this.props.storyLocks,
                    [storyId]: {
                        userId: userId,
                        connectionId: null,
                        lockTime: new Date().toISOString()
                    }
                });
            }

            this.refreshTableData();
        });
    }

    onOpenForm = (formType, rowAction, dataObj) => {

        if (rowAction === TableRowAction.EDIT_INFO_BY_FORM &&
            formType === HubConstant.HUB_STORY_EDIT_FORM &&
            dataObj && dataObj.id) {

            const storyId = dataObj.id;
            const x = authService.getCurrentHubUser();

            const lockedStoryInfo = this.state.lockedStories[storyId];
            const isLockedByMe = lockedStoryInfo && lockedStoryInfo.lockedByMe;

            if (isLockedByMe) {
                this.props.onOpenForm(formType, rowAction, {
                    ...dataObj,
                    onFormClose: () => this.handleEditFormClose(storyId)
                });
                return;
            }

            const isLocked = this.isStoryLocked(storyId);
            if (isLocked) {
                const lockUserId = lockedStoryInfo ? lockedStoryInfo.userId :
                    (this.props.storyLocks && this.props.storyLocks[storyId] ? this.props.storyLocks[storyId].userId : null);
                return;
            }
            const userId = authService.getCurrentHubUser().id;

            storyLockClient.requestLock(storyId, userId)
                .then(lockAcquired => {
                    if (!lockAcquired) {
                        Logger.warn("Failed to acquire lock for story:", storyId);
                    }
                })
                .catch(error => {
                    Logger.error("Error requesting lock:", error);
                });
            return;
        }

        this.props.onOpenForm(formType, rowAction, dataObj);
    }

    handleEditFormClose = async (storyId) => {
        try {
            await storyLockClient.releaseLock(storyId);

            this.setState(prevState => {
                const newLockedStories = { ...prevState.lockedStories };
                delete newLockedStories[storyId];
                return { lockedStories: newLockedStories };
            }, () => {
                if (this.props.updateStoryLocks) {
                    const updatedReduxLocks = { ...this.props.storyLocks };
                    delete updatedReduxLocks[storyId];
                    this.props.updateStoryLocks(updatedReduxLocks);
                }

                this.refreshTableData();
            });
        } catch (error) {
            Logger.error("Error releasing lock:", error);
        }
    }

    handleInitialLocks = (locks) => {
        Logger.debug("Received initial locks:", locks);

        if (!locks) return;

        const currentUserId = authService.getCurrentHubUser().id;
        const currentConnectionId = storyLockClient.getConnectionId();
        const newLockedStories = {};
        const reduxLocks = {};

        Object.entries(locks).forEach(([storyId, lockInfo]) => {
            const storyIdNum = parseInt(storyId);
            const isMyLockButStale = lockInfo.userId === currentUserId &&
                lockInfo.connectionId !== currentConnectionId;

            if (isMyLockButStale) {
                Logger.debug(`Releasing stale lock for story ${storyId} from previous session`);
                storyLockClient.releaseLock(storyIdNum);
                return;
            }

            newLockedStories[storyIdNum] = {
                lockedByMe: lockInfo.userId === currentUserId && lockInfo.connectionId === currentConnectionId,
                userId: lockInfo.userId,
                connectionId: lockInfo.connectionId,
            };

            reduxLocks[storyIdNum] = {
                userId: lockInfo.userId,
                connectionId: lockInfo.connectionId,
                lockTime: lockInfo.lockTime
            };

            const user = this.props.users ? this.props.users.find(u => u.id === lockInfo.userId) : null;
            const userName = user ? user.userName : `User ID: ${lockInfo.userId}`;
            Logger.debug(`Story ${storyId} is locked by ${userName} (lockedByMe: ${lockInfo.userId === currentUserId && lockInfo.connectionId === currentConnectionId})`);
        });

        this.setState({ lockedStories: newLockedStories }, () => {
            // After locks are loaded, refresh the table to show lock icons
            if (this.props.objectList && this.props.objectList.length > 0) {
                const transformedTableData = this.fetchData(this.props.objectList);
                this.setState({ fetchedData: transformedTableData });
            }
        });

        if (this.props.updateStoryLocks) {
            this.props.updateStoryLocks(reduxLocks);
        }
    }

    handleLockReleased = (storyId) => {
        Logger.debug("Lock released for story:", storyId);

        let updatedReduxLocks = {};
        if (this.props.updateStoryLocks) {
            updatedReduxLocks = { ...this.props.storyLocks };
            delete updatedReduxLocks[storyId];
            this.props.updateStoryLocks(updatedReduxLocks);
        }

        // Remove from local state
        const newLockedStories = { ...this.state.lockedStories };
        delete newLockedStories[storyId];

        this.setState({ lockedStories: newLockedStories }, () => {
            this.refreshTableData();
        });
    }

    isStoryLocked = (storyId) => {
        const isLockedInRedux = this.props.storyLocks && this.props.storyLocks[storyId] !== undefined;
        const isLockedInLocal = !this.props.storyLocks && this.state.lockedStories[storyId] !== undefined;
        return isLockedInRedux || isLockedInLocal;
    }

    getAryVal = function (x, y) {
        return _.differenceBy(x, y, 'id').concat(_.differenceBy(x, y, 'newsContent').concat(_.differenceBy(x, y, 'subObjectState')));
    }

    isArrayEqual = function (x, y) {
        //return _(x).xorWith(y, _.isEqual).isEmpty();
        //TODO: Implement scn detection for updates:
        //var aDiff = _.differenceBy(x, y, 'id').concat(_.differenceBy(x, y, 'newsContent').concat(_.differenceBy(x, y, 'subObjectState'))); 
        var isArrayEqual_Memoized = memoize(this.getAryVal)
        var aDiff = isArrayEqual_Memoized(x, y)
        return aDiff.length <= 0;
    };

    // //To properly map the fetchedData variable to redux:
    componentWillReceiveProps(nextPropsFromRedux) {
        let shouldRefreshTable = false;
        if (this._isMounted
            && (nextPropsFromRedux.bTriggerUpdate
                || nextPropsFromRedux.clickNotifier != this.props.clickNotifier
                || nextPropsFromRedux.action != this.props.action
                || nextPropsFromRedux.objectList !== this.props.objectList)) { 

            Logger.debug('nextPropsFromRedux: ', nextPropsFromRedux)

            if (nextPropsFromRedux.storyLocks !== this.props.storyLocks) {

                const oldProps = this.props;
                this.props = nextPropsFromRedux;
                const cleanupHappened = this.cleanupStaleLocalLocks();
                this.props = oldProps;

                if (cleanupHappened) {
                    shouldRefreshTable = true;
                }
            }

            var transformedTableData;
            if (!!nextPropsFromRedux.objToUpdate) {
                transformedTableData = this.fetchData(nextPropsFromRedux.objectList, nextPropsFromRedux.objToUpdate, nextPropsFromRedux.storyLocks)
            } else {
                transformedTableData = this.fetchData(nextPropsFromRedux.objectList, null, nextPropsFromRedux.storyLocks)
            }

            this.setState({ fetchedData: transformedTableData })
            this.props.onFinishStoryUpdate()
        }
    }

    parseCollapsibleData(dataObj) {
        var collapsedData = [
            { rowType: CollapsibleRowType.REGULAR, val: "Story Number: ", colsOccupied: 1, hideIfNull: dataObj.id },
            { rowType: CollapsibleRowType.REGULAR, val: dataObj.id, colsOccupied: 1, hideIfNull: dataObj.id },
            { rowType: CollapsibleRowType.REGULAR, val: "Story Runtime: ", colsOccupied: 1, hideIfNull: dataObj.runTime },
            { rowType: CollapsibleRowType.REGULAR, val: Utilities.formatRunTime(dataObj.runTime), colsOccupied: 1, hideIfNull: dataObj.runTime },
            { rowType: CollapsibleRowType.REGULAR, val: "Text Read Time: ", colsOccupied: 1, hideIfNull: dataObj.readTime },
            { rowType: CollapsibleRowType.REGULAR, val: Utilities.formatRunTime(dataObj.readTime), colsOccupied: 1, hideIfNull: dataObj.readTime },

            { rowType: CollapsibleRowType.REGULAR, val: "Word Count: ", colsOccupied: 1, hideIfNull: dataObj.wordCount },
            { rowType: CollapsibleRowType.REGULAR, val: dataObj.wordCount, colsOccupied: 1, hideIfNull: dataObj.wordCount },
            { rowType: CollapsibleRowType.REGULAR, val: "Urgency: ", colsOccupied: 1, hideIfNull: dataObj.priorityLevel, isUrgency: true },
            { rowType: CollapsibleRowType.REGULAR, val: Utilities.formatUrgency(dataObj.priorityLevel), colsOccupied: 1, hideIfNull: dataObj.priorityLevel, isUrgency: true, isUrgencyVal: true },
            { rowType: CollapsibleRowType.REGULAR, metadataId: 1, isMetadataName: true, colsOccupied: 1, hideIfNull: dataObj.id },
            { rowType: CollapsibleRowType.REGULAR, metadataId: 1, isMetadataVals: true, colsOccupied: 1, hideIfNull: dataObj.id },

            { rowType: CollapsibleRowType.PARAGRAPH, key: "Text", val: navigateDataObj(dataObj, ["newsContent", "script"]), hideIfNull: dataObj.id }
        ]

        for (var i = 0; i < dataObj.subObjectCount; i++) {
            collapsedData.push(
                {
                    rowType: CollapsibleRowType.WHOLE_COL_RIGHT,
                    fetchId: dataObj.id,
                    elementId: navigateDataObj(dataObj, ["newsContent", "elements", i, "id"]),
                    contentType: navigateDataObj(dataObj, ["newsContent", "elements", i, "newsContent", "type", "id"]),
                    mediaFetchUrl: `/api/element/${navigateDataObj(dataObj, ["newsContent", "elements", i, "id"])}/mediaobject?oauth_token=${authService._accessToken}`,
                    elementName: navigateDataObj(dataObj, ["newsContent", "elements", i, "name"]),
                    mimeType: navigateDataObj(dataObj, ["newsContent", "elements", i, "newsContent", "type", "mimeType"]),
                    outQ: navigateDataObj(dataObj, ["newsContent", "elements", i, "newsContent", "outQ"]),
                    verbatim: navigateDataObj(dataObj, ["newsContent", "elements", i, "newsContent", "verbatim"]),
                    hideIfNull: (dataObj.subObjectCount > 0) ? dataObj.id : null
                }

                // right now, all the collapsibleData is being fetched by DataTable.  When the api call is done to attempt to refresh a specific collapsible row
                // it never gets updated, unless I update the fetchedCollapsibleData state...
                // therefore, I have to let the Context (i.e., Story) handle the data, then pass all the data/collapsible row data to the collapsible row...
                // Context: convert collapsible data of each newsItem from redux into data passable to datatable
                // redux: stores collapsible data of each newsItem
                // dataTable: if (!!dataObj.collapsibledata) render collapsible row, or else parseCollapsibleData() from redux by Context
            )
        }


        return collapsedData;
    }

    filterStoryData(obj) {
        return obj.objectType.type === "Story" && (
            this.state.hasMediaCheckboxState === DataTableConstant.HUB_CHECKBOX_STATE.EMPTY ||
            (this.state.hasMediaCheckboxState === DataTableConstant.HUB_CHECKBOX_STATE.TICK && obj.subObjectCount > 0) ||
            (this.state.hasMediaCheckboxState === DataTableConstant.HUB_CHECKBOX_STATE.CROSS && obj.subObjectCount === 0)) && (
                this.state.urgentCheckboxState === DataTableConstant.HUB_CHECKBOX_STATE.EMPTY ||
                (this.state.urgentCheckboxState === DataTableConstant.HUB_CHECKBOX_STATE.TICK && Utilities.formatUrgency(obj.priorityLevel) === 'Urgent') ||
                (this.state.urgentCheckboxState === DataTableConstant.HUB_CHECKBOX_STATE.CROSS && Utilities.formatUrgency(obj.priorityLevel) !== 'Urgent'))
    }

    onEditOutQ = (outQData, newsItemId) => {
        //open out-Q editing form:
        Logger.debug("OBJECT: ", { ...outQData, ...{ newsItemId: newsItemId } })
        this.props.onOpenForm(HubConstant.HUB_OUTQ_FORM, null, { ...outQData, ...{ newsItemId: newsItemId } })
    }

    onDeleteObjectClick = async (objectType, objectId, folderId) => {

        if (this.isStoryLocked(objectId)) {
            Logger.debug("Cannot delete locked story:", objectId);
            return;
        }
        await this.props.onDeleteNewsItemInFolder(objectType, objectId, folderId);
    }

    onEditObjectClick = async ( objectId ) => {
        Logger.debug("Edit object clicked:", objectId);
        const userId = authService.getCurrentHubUser().id;

        await storyLockClient.requestLock(objectId, userId);
    }

    onParseCollapsibleData = async (newsItemId) => {
        Logger.debug("CALLED1")
        var t0 = performance.now()
        await this.props.getNewsItemSubObject(newsItemId)
        var t1 = performance.now()
        Logger.debug("Call to onParseCollapsibleData took " + (t1 - t0) + " milliseconds.")
        // this.props.getNewsItemMetadata(newsItemId)
    }

    fetchData(objects, objToUpdate, storyLocks) {
        Logger.debug("call to fetch? ", objToUpdate)
        if (!!objToUpdate) {
            var t0 = performance.now()
            var objIndex = this.state.fetchedData.findIndex(dataObj => dataObj.id === objToUpdate.id)
            if (objIndex !== -1) {
                const dataObj = objects.find(dataObj => dataObj.id === objToUpdate.id)
                var updatedObj = update(this.state.fetchedData, {
                    [objIndex]: {
                        Collapsible: {
                            ... objToUpdate.type === HubConstant.HUB_NEWSITEM_UPDATE_TYPE.SUBOBJECT &&
                            {
                                data: { $set: this.parseCollapsibleData(dataObj) },
                                state: { $set: !!dataObj.subObjectState ? dataObj.subObjectState : HubConstant.HUB_SUBOBJECT_STATE.IDLE }
                            }, // just so you know, HUB_SUBOBJECT_STATE === HUB_COLLAPSIBLE_ROW_STATE
                            ... objToUpdate.type === HubConstant.HUB_NEWSITEM_UPDATE_TYPE.SUBOBJECT_METADATA && {metadata:
                                    { $set: onReceivePropsParseMetadata(dataObj, this.props.metadata) }
                            }
                        },
                        folderId: { $set: dataObj.folderId }
                    }
                })
                Logger.debug('updatedObj:', updatedObj);
            }
            var t1 = performance.now()
            Logger.debug(`Call to ${objToUpdate.type} took ` + (t1 - t0) + " milliseconds.")
            return updatedObj
        } else if (objects !== undefined && objects != null && objects.length > 0) {
            var t0 = performance.now()
            var newObj = objects.filter((o) => this.filterStoryData(o)).map((o) => {

                const storyLocksToUse = storyLocks || this.props.storyLocks;

                const isLockedInRedux = storyLocksToUse && storyLocksToUse[o.id] !== undefined;
                const isLockedInLocal = !storyLocksToUse && this.state.lockedStories[o.id] !== undefined;
                const isLockedInObject = o.isLocked === true || o.lockedBy !== undefined;

                const isLocked = isLockedInRedux || isLockedInLocal || isLockedInObject;

                let lockedByMe = false;
                let lockUserName = "Another user";
                let lockUserId = null;

                if (isLocked) {
                    const currentUserId = authService.getCurrentHubUser().id;
                    const currentConnectionId = storyLockClient.getConnectionId();

                    if (isLockedInRedux) {
                        lockUserId = storyLocksToUse[o.id].userId;
                        const lockConnectionId = storyLocksToUse[o.id].connectionId;
                        lockedByMe = lockUserId === currentUserId && lockConnectionId === currentConnectionId;

                    } else if (isLockedInLocal) {
                        const localLock = this.state.lockedStories[o.id];
                        lockUserId = localLock.userId;
                        lockedByMe = localLock.lockedByMe;

                    } else if (isLockedInObject) {
                        lockUserId = o.lockedBy;
                        const lockConnectionId = o.lockConnectionId;
                        lockedByMe = lockUserId === currentUserId && lockConnectionId === currentConnectionId;
                    }

                    if (lockUserId && this.props.users) {
                        const user = this.props.users.find(u => u.id === lockUserId);
                        if (user) {
                            lockUserName = user.userName;
                        }
                    }
                }

                const isLockedByOther = isLocked && !lockedByMe;

                return ({
                    //Lower case keys won't get posted to table
                    id: o.id,
                    folderId: !!o.folderId ? o.folderId : this.props.hubWorkingFolder.id,
                    type: HubConstant.HUB_OBJECT_STORY,
                    subObjectCount: o.subObjectCount,
                    isUrgent: Utilities.formatUrgency(o.priorityLevel) === 'Urgent',
                    ProductionCentre: { val: o.origin ? authService.getHubNodeName(o.origin.nodeId) : authService.getNodeNameByUserId(o.createInfo.id), canSort: true, headerIcon: faCity },
                    Title: {
                        val: o.name,
                        canSort: true,
                    },
                    Arrived: {
                        val: Utilities.formatObjectDate(!!o.folderArrivalTime ? o.folderArrivalTime : o.createInfo.time, UtilConstant.HUB_TIME_FORMAT.CANADIAN), canSort: true, date: !!o.folderArrivalTime ? o.folderArrivalTime : o.createInfo.time, isInitiallySorted: true,
                        rowIcon: Math.round(Math.round((new Date() - new Date(!!o.folderArrivalTime ? o.folderArrivalTime : o.createInfo.time)) / 1000) / 60) <= 9 ? <FontAwesomeIcon icon={faCertificate} /> : undefined,
                        hasRowIcon: true, headerIcon: faPlaneArrival
                    },
                    CreatedBy: { val: authService.getCreatorName(o.createInfo.id), canSort: false, headerIcon: faUserEdit },

                    Duration: { val: Utilities.formatRunTime(o.runTime, false), canSort: true, headerIcon: faStopwatch },
                    Tags: { val: o.keyword, canSort: false, headerIcon: faTags },
                    Collapsible: {
                        id: o.id,
                        numOfColsPerRow: 6,
                        data: this.parseCollapsibleData(o),
                        metadata: onReceivePropsParseMetadata(o, this.props.metadata),
                        //isLoading: false, //for the loading icon
                        state: !!o.subObjectState ? o.subObjectState : HubConstant.HUB_SUBOBJECT_STATE.IDLE, // just so you know, HUB_SUBOBJECT_STATE === HUB_COLLAPSIBLE_ROW_STATE
                        onPreviewMedia: (mediaId) => { Logger.debug("MEDIAID", mediaId); HubApi.previewMediaObj(!!mediaId ? mediaId : o.id) },
                        onDownloadMedia: async (mediaId, mediaName) => await HubApi.downloadMediaObj(!!mediaId ? mediaId : o.id, !!mediaName ? mediaName : o.name),
                        onEditOutQ: (mediaId) => this.onEditOutQ(mediaId, o.id),
                        fetchData: async () => await this.onParseCollapsibleData(o.id),
                        fetchNewsItemMetadata: async () => this.props.getNewsItemMetadata(o.id)
                    },
                    rowActions: [
                        {
                            action: TableRowAction.EDIT_INFO_BY_FORM,
                            form: HubConstant.HUB_STORY_EDIT_FORM,
                            minAuthorityRequired: UtilConstant.HUB_USER_TYPE.HUB_USER,
                            userPermission: HubConstant.USER_FOLDER_PERMISSIONS.MODIFY,
                            tooltipText: isLockedByOther ? `Locked by ${lockUserName}` : "Edit Story",
                            disableCondition: isLockedByOther,  
                            isLocked: isLockedByOther,          
                            lockUserName: lockUserName,
                        },
                        {
                            action: TableRowAction.DELETE_ROW,
                            minAuthorityRequired: UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN,
                            userPermission: HubConstant.USER_FOLDER_PERMISSIONS.DELETE,
                            tooltipText: isLockedByOther ? `Locked by ${lockUserName}` : "Delete Story",
                            disableCondition: isLockedByOther,  
                            isLocked: isLockedByOther,         
                            lockUserName: lockUserName,
                        },
                        {
                            action: TableRowAction.MOVE_FOLDER_ROW,
                            form: HubConstant.MOVE_NEWSITEM_FOLDER_FORM,
                            minAuthorityRequired: UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN,
                            userPermission: HubConstant.USER_FOLDER_PERMISSIONS.DELETE,
                            tooltipText: isLockedByOther ? `Locked by ${lockUserName}` : "Move Story",
                            disableCondition: isLockedByOther,  
                            isLocked: isLockedByOther,          
                            lockUserName: lockUserName,
                        },
                        {
                            action: TableRowAction.DOWNLOAD_ALL_MEDIA,
                            minAuthorityRequired: UtilConstant.HUB_USER_TYPE.HUB_USER,
                            userPermission: HubConstant.USER_FOLDER_PERMISSIONS.READ,
                            onClickDownloadAllMedia: async () => await HubApi.downloadMediaObj(o.id, o.name, true),
                            disableNodeAuthorityCheck: true
                        },
                    ]
                }
                );
            })
            var t1 = performance.now()
            console.log("Call to fetchData took " + (t1 - t0) + " milliseconds.")
            return newObj
        } else {
            return [];
        }
    }

    onChangeFilterBar = (filters, requireAPIRefresh) => {
        Logger.debug(filters);
        var nodeIds = filters.find(filter => filter.title === "Production Centre").toFilter.map(filteredNode => filteredNode.id);
        var categories = {
            id: 1,
            name: filters.find(filter => filter.title === "Category").toFilter.map(filteredCat => filteredCat.name)
        }
        this.setState({
            urgentCheckboxState: filters.find(filter => filter.title === "Urgent").state,
            hasMediaCheckboxState: filters.find(filter => filter.title === "Has Media").state
        })
        //TODO: (if more time: requireAPIRefresh only for api-required filters, not urgent/hasmedia)
        //if (!!requireAPIRefresh) this.props.setNodeFilter(nodeIds, HubConstant.HUB_OBJECT_STORY, categories);
        this.props.setFilterForNewsItemInFolder(this.props.hubWorkingFolder.id, HubConstant.HUB_OBJECT_STORY, nodeIds, categories);
        //this.props.setNodeFilter(nodeIds, HubConstant.HUB_OBJECT_STORY, categories);
    }

    //backup data stub for no val
    displayDatatable() {
        const { onOpenForm, ...otherProps } = this.props;

        return (
            <Row className="tableRow">
                <Col xs="12">
                    <DataTable canDeleteRow={true}
                        headerConfig={this.headerConfig}
                        data={this.state.fetchedData}
                        folder={this.props.hubWorkingFolder}
                        tools={[
                            { action: TableToolType.FULL_TEXT_SEARCH },
                            { action: TableToolType.SHOW_NUM_ROWS_DROPDOWN },
                            { action: TableToolType.FILTER_SEARCH },
                            { action: TableToolType.SYNC },
                            { action: TableToolType.ADD, form: HubConstant.HUB_STORY_FORM, userPermission: HubConstant.USER_FOLDER_PERMISSIONS.CREATE },
                            { action: TableToolType.PAGE_DISPLAY },
                            { action: TableToolType.PAGINATION },
                            {
                                action: TableToolType.FILTER_BAR,
                                filters: [
                                    {
                                        type: DataTableConstant.HUB_FILTER_TYPE.MULTI_VAL_SELECTOR,
                                        title: "Production Centre",
                                        icon: faCity,
                                        availableFilterObjs: extractNodesFromData(this.props.nodes, this.props.hubNodeGroups),
                                        availableFilterGroups: extractNodeGroups(this.props.hubNodeGroups)
                                    },
                                    {
                                        type: DataTableConstant.HUB_FILTER_TYPE.MULTI_VAL_SELECTOR,
                                        title: "Category",
                                        icon: faListAlt,
                                        availableFilterObjs: extractCategories(this.props.metadata)
                                    },
                                    { type: DataTableConstant.HUB_FILTER_TYPE.CHECKBOX, title: "Urgent", icon: faExclamationTriangle },
                                    { type: DataTableConstant.HUB_FILTER_TYPE.CHECKBOX, title: "Has Media", icon: faFileAudio }
                                ],
                                onChangeFilters: this.onChangeFilterBar
                            }
                        ]}
                    // filterBarConfig={{
                    //     types: [
                    //         HubFilterType.PRODUCTION_CENTRE,
                    //         HubFilterType.CATEGORY,
                    //         HubFilterType.URGENT,
                    //         HubFilterType.HAS_MEDIA
                    //     ]
                    // }}
                        dataAction={this.props.action}
                        onDeleteObjectClick={this.onDeleteObjectClick}
                        onOpenForm={this.onOpenForm}
                        isNotificationDisallowed={this.props.isNotificationAllowed}
                        authorizeService={authService}
                        {...otherProps}></DataTable>
                </Col>
            </Row>
        )
    }

    render() {
        //DataTable happens during component will mount, make sure that data is fetched before table is rendered:
        return (
            <div className="Story">
                <Row className="structureRow">
                    <Col xs="12">
                        {(!!this.state.fetchedData) ? this.displayDatatable() : <Fragment key="0"></Fragment>}
                    </Col>
                </Row>
            </div>
        )
    }
}

Story.propTypes = {
    objectType: PropTypes.number,
    nodeId: PropTypes.number
};


Story.defaultProps = {
    nodeId: 0
};

const mapHubObjectAndMetadataStatesToProps = (state) => {
    return {
        objectList: state.hubObjectContent.objectList,
        objToUpdate: state.hubObjectContent.objToUpdate,
        action: state.hubObjectContent.action,
        hubNodeGroups: state.hubObjectContent.hubNodeGroups,
        hubWorkingFolder: state.hubObjectContent.hubWorkingFolder,
        metadata: state.hubConfig.hubMetadata.metaData,
        nodes: state.hubConfig.nodeConfig.nodes,
        bTriggerUpdate: state.hubObjectContent.bTriggerUpdate,
        storyLocks: state.hubObjectContent.storyLocks,
        users: state.hubConfig.userConfig.users
    }
}

export default withRouter(connect(
    mapHubObjectAndMetadataStatesToProps,
    dispatch => bindActionCreators({ ...mapDispatchToProps, ...mapDispatchToMetadataProps, ...mapDispatchToHubObjectBoardProps }, dispatch)
)(Story));